export default __webpack_public_path__ + "static/media/stephanie-sher.1ed756a1.jpeg";